/**
 * tdesign v0.48.5
 * (c) 2022 tdesign
 * @license MIT
 */

import Vue from 'vue';
import props from '../props.js';
import { removeDom, getAttach } from '../../utils/dom.js';
import 'raf';
import 'lodash/isString';
import '../../utils/easing.js';

var Container = Vue.extend({
  props: {
    mode: props.mode,
    renderModal: Function,
    renderViewer: Function
  },
  data: function data() {
    return {
      content: null
    };
  },
  methods: {
    mountContent: function mountContent() {
      if (this.content) return;

      var _this = this;

      var elm = document.createElement("div");
      elm.style.cssText = "position: absolute; top: 0px; left: 0px; width: 100%";
      this.content = new this.$root.constructor({
        render: function render() {
          return _this.mode === "modeless" ? _this.renderModal() : _this.renderViewer();
        },
        destroyed: function destroyed() {
          if (_this.content.$el) {
            removeDom(_this.content.$el);
          }

          _this.content = null;
        }
      });
      getAttach(document.body).appendChild(elm);
      this.content.$mount(elm);
    },
    unmountContent: function unmountContent() {
      var _this$content, _this$content$$destro;

      (_this$content = this.content) === null || _this$content === void 0 ? void 0 : (_this$content$$destro = _this$content.$destroy) === null || _this$content$$destro === void 0 ? void 0 : _this$content$$destro.call(_this$content);
    }
  },
  render: function render() {
    var _children$;

    var h = arguments[0];
    var children = this.$slots["default"] || [];

    if (children.length > 1 || !((_children$ = children[0]) !== null && _children$ !== void 0 && _children$.tag)) {
      return h("span", [children]);
    }

    return children[0];
  }
});

export { Container as default };
//# sourceMappingURL=Container.js.map
